import React, { useState } from "react";
import useExerciseDetails from "../../hooks/useExerciseDetails";
import { Exercise } from "../../../../models/Exercise";
import { Assort } from "../../../../models/Assort";
import { TicketAccess } from "../../../../models/TicketAccess";
import "./SingleExerciseDetailsModal.scss";
import EAModal from "../../../shared/Modal/EAModal";
import ExerciseImageHeader from "./ExerciseImageHeader";
import ExerciseInfoContent from "./ExerciseInfoContent";
import TicketPurchaseContent from "./TicketPurchaseContent";

type ViewMode = "info" | "ticket-purchase";

interface IProps {
  exercise: Exercise;
  onClose: () => void;
  ticketsListLength: number;
  handleModals: (value: string) => void;
  onRefreshExercises: () => void;
  tickets?: Assort[];
  ticketAccess?: TicketAccess;
}

const SingleExerciseDetailsModal: React.FC<IProps> = ({
  exercise,
  onClose,
  ticketsListLength,
  handleModals,
  onRefreshExercises,
  tickets = [],
  ticketAccess,
}) => {
  const [viewMode, setViewMode] = useState<ViewMode>("info");
  const { exerciseDetails, handleJoinToExercise, alerts, handleLeaveFromExercise, joinErrorData, showLoginButton } =
    useExerciseDetails(exercise, onRefreshExercises);

  const handleSwitchToTicketPurchase = () => {
    setViewMode("ticket-purchase");
  };

  const handleBackToInfo = () => {
    setViewMode("info");
  };


  return (
    <div className="schedule-modal-info">
      <EAModal isOpen onClose={onClose} title={""} hideButtons isCloseButton={false} desktopWidth="1000px">
        <div className="single-exercise-details-modal__container">
          <div className="single-exercise-details-modal__left-column">
            <ExerciseImageHeader exercise={exerciseDetails} />
          </div>
          <div className="single-exercise-details-modal__right-column">
            {viewMode === "info" ? (
              <ExerciseInfoContent
                handleModals={handleModals}
                joinToExercise={handleJoinToExercise}
                exercise={exerciseDetails}
                alerts={alerts}
                assignedStatus={exerciseDetails.assigned}
                ticketsListLength={ticketsListLength}
                leaveFromExercise={handleLeaveFromExercise}
                joinErrorData={joinErrorData}
                showLoginButton={showLoginButton}
                onClose={onClose}
                onSwitchToTicketPurchase={handleSwitchToTicketPurchase}
              />
            ) : (
              <>
                <TicketPurchaseContent
                  exercise={exerciseDetails}
                  tickets={tickets}
                  ticketAccess={ticketAccess}
                  onBack={handleBackToInfo}
                  onClose={onClose}
                />
              </>
            )}
          </div>
        </div>
      </EAModal>
    </div>
  );
};

export default SingleExerciseDetailsModal;
